/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ProductDetailDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class CrawlerService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags CrawlerService
   * @name GetProductDetails
   * @summary Get Product Details from Various Sites
   * @request GET:/v1/products/crawl
   * @secure
   */
  getProductDetails = (
    query: {
      'target-url': string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProductDetailDto, any>({
      path: `/v1/products/crawl`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
